<template>
  <!-- <ConfirmationModal></ConfirmationModal> -->
  <div class="emptyGridMsgSec" v-if="userListObject.length == 0">
    <i class="mdi mdi-note-outline"></i>
    <h3>No Record Found</h3>
    <p class="text-muted">
      We didn't find anything to show here, please add new users
    </p>
  </div>
  <div v-if="userListObject.length > 0">
    <DataTable
      class="table-responsive"
      v-model:filters="filters"
      :value="userListObject"
      paginator
      :rows="5"
      :rowsPerPageOptions="[5, 10, 20, 50]"
      stripedRows
      scrollable
      scrollHeight="400px"
      tableStyle="min-width: 50rem"
      style="overflow-x: hidden"
    >
      <template #header>
        <div class="row justify-content-between">
          <div class="col-4">
            <BFormInput
              id="inline-form-input-name"
              class="form-control form-control-lg"
              placeholder="Search"
              v-model="filters['global'].value"
            />
            <!-- v-model="filters['global'].value" -->
          </div>
          <div class="col-4">
            <a
              class="btn btn-block btn-lg btn-gradient-primary"
              style="float: right"
              @click="exportToCSV($event)"
              ><i class="mdi mdi-export"></i> Export</a
            >
          </div>
        </div>
      </template>
      <template #empty> No data found. </template>

      <Column header="Sr. no" headerStyle="width:3rem">
        <template #body="slotProps">
          {{ slotProps.index + 1 }}
        </template>
      </Column>

      <Column
        v-for="col of columns"
        :key="col.field"
        :field="col.field"
        :header="col.header"
        sortable
      ></Column>

      <Column field="usr_created_on" header="Created On" sortable>
        <template #body="slotProps">
          {{ formatDateTime(slotProps.data.usr_created_on) }}
        </template>
      </Column>
      <Column field="usr_status" header="Status" sortable>
        <template #body="slotProps">
          <span
            :class="[
              slotProps.data.usr_status == 0
                ? 'badge badge-gradient-danger'
                : 'badge badge-gradient-success',
            ]"
            style="font-size: 0.875rem"
          >
            {{ slotProps.data.usr_status == 1 ? "Active" : "Deactive" }}
          </span>
        </template>
      </Column>
      <!-- <Column header="Status" field="user_status" :filterMenuStyle="{ width: '14rem' }" style="min-width: 12rem">
                <template #body="slotProps">
                    <Tag :value="slotProps.data.user_status== 1 ? 'Active' : 'Deactive'" :severity="getSeverity(slotProps.data.user_status1 ? 'Active' : 'Deactive')" />
                </template>
                <template #filter="{ filterModel }">
                    <Select v-model="filterModel.value" :options="statuses" placeholder="Select One" showClear>
                        <template #option="slotProps">
                            <Tag :value="slotProps.option" :severity="getSeverity(slotProps.option)" />
                        </template>
                    </Select>
                </template>
            </Column> -->
      <Column header="Actions" style="width: 10%; min-width: 8rem">
        <template #body="slotProps">
          <a
            class="btn-grid-action"
            title="Click to Deactive"
            @click="manageActiveStatus(slotProps.data)"
            v-if="slotProps.data.usr_status == 1"
          >
            <i class="mdi mdi-account-off mdi-24px"></i>
          </a>
          <a
            class="btn-grid-action"
            title="Click to Active"
            @click="manageActiveStatus(slotProps.data)"
            v-if="slotProps.data.usr_status == 0"
          >
            <i class="mdi mdi mdi-account-check mdi-24px"></i>
          </a>
          <a
            class="btn-grid-action"
            title="Click to Modify"
            @click="editUserDetails(slotProps.data)"
          >
            <i class="mdi mdi-border-color mdi-24px"></i>
          </a>
          <a
            class="btn-grid-action"
            title="Click to Reset Password"
            @click="btnResetPassClick(slotProps.data)"
          >
            <i class="mdi mdi mdi-lock mdi-24px"></i>
          </a>
          <!-- <a class="btn-grid-action" title="Click to Modify" @click="requireConfirmation()">
                        <i class="mdi mdi-border-color mdi-24px"></i>
                    </a> -->
        </template>
      </Column>
    </DataTable>
  </div>
  <Dialog
    v-model:visible="visible"
    modal
    header="Edit Profile"
    :style="{ width: '25rem' }"
  >
    <template #header>
      <div class="inline-flex align-items-center justify-content-center gap-2">
        <Avatar
          icon="mdi mdi-account menu-icon"
          class="mr-2"
          size="xlarge"
          shape="circle"
        />
        <span class="font-bold white-space-nowrap">{{
          selectedUser.usr_user_name
        }}</span>
      </div>
    </template>
    <span class="p-text-secondary block mb-5">Reset user password.</span>
    <BForm>
      <div class="row">
        <div class="form-group">
          <label for="exampleInputPassword4"
            >Password<span class="mandatory-sign">*</span></label
          >
          <BInputGroup class="mt-3">
            <template #append>
              <BInputGroupText
                style="font-size: 1.2rem"
                @click="showPass ? (showPass = false) : (showPass = true)"
                ><i :class="!showPass ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"></i>
              </BInputGroupText>
            </template>
            <BFormInput
              id="inline-form-input-name"
              :type="showPass ? 'text' : 'password'"
              v-model="reset_pass_form.usr_password"
              class="form-control form-control-lg"
              placeholder="Password"
              :state="is_valid_user_pass"
              aria-describedby="input_error_user_pass"
              title="Must contain at least one number and one uppercase and lowercase letter, 
                            and at least 8 or more characters"
              @change="onChangePass($event)"
              minlength="8"
              maxlength="100"
            />
          </BInputGroup>

          <BFormInvalidFeedback
            id="input_error_user_pass"
            style="display: block"
            v-if="is_valid_user_pass != null && !is_valid_user_pass"
          >
            Enter password
          </BFormInvalidFeedback>
        </div>
        <div class="form-group">
          <label for="exampleInputPassword4"
            >Confirm Password<span class="mandatory-sign">*</span></label
          >
          <BInputGroup class="mt-3">
            <template #append>
              <BInputGroupText
                style="font-size: 1.2rem"
                @click="
                  showConfirmPass
                    ? (showConfirmPass = false)
                    : (showConfirmPass = true)
                "
                ><i
                  :class="!showConfirmPass ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"
                ></i>
              </BInputGroupText>
            </template>
            <BFormInput
              id="inline-form-input-name"
              :type="showConfirmPass ? 'text' : 'password'"
              v-model="reset_pass_form.usr_confirm_pass"
              class="form-control form-control-lg"
              placeholder="Confirm Password"
              :state="is_valid_user_pass"
              aria-describedby="input_error_user_pass"
              title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters"
              @change="onChangePass($event)"
              minlength="8"
              maxlength="100"
            />
          </BInputGroup>

          <BFormInvalidFeedback
            id="input_error_user_confirm_pass"
            style="display: block"
            v-if="confirm_pass_val_msg != null && !is_valid_user_confirm_pass"
          >
            {{ confirm_pass_val_msg }}
          </BFormInvalidFeedback>
        </div>
      </div>
      <div class="row">
        <ul class="requirements">
          <li
            v-for="(requirement, key) in passwordRequirements"
            :key="key"
            :class="requirement.predicate ? 'is-success' : 'is-error'"
          >
            {{ requirement.name }}
          </li>
        </ul>
      </div>
    </BForm>

    <template #footer>
      <!-- <Button label="Cancel" text severity="secondary" @click="visible = false" autofocus />
            <Button label="Save" outlined severity="secondary" @click="visible = false" autofocus /> -->
      <BButton
        class="btn btn-block btn-gradient-success btn-lg font-weight-medium auth-form-btn"
        @click="resetPassword()"
        type="submit"
        >Submit
      </BButton>
      <BButton class="btn btn-light" @click="visible = false">Cancel </BButton>
    </template>
  </Dialog>
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div
        class="flex flex-column align-items-center p-5 surface-overlay border-round"
      >
        <div
          class="border-circle bg-gradient-primary inline-flex justify-content-center align-items-center text-white h-6rem w-6rem -mt-8"
        >
          <i
            class="mdi mdi-account-off mdi-24px"
            v-if="actionType == 'deactive'"
          ></i>
          <i
            class="mdi mdi-account-check mdi-24px"
            v-if="actionType == 'active'"
          ></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-4">{{
          message.header
        }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex align-items-center gap-2 mt-4">
          <!-- <Button label="Save" @click="acceptCallback"></Button>
                    <Button label="Cancel" outlined @click="rejectCallback"></Button> -->
          <BButton
            class="btn btn-block btn-gradient-success btn-lg font-weight-medium auth-form-btn"
            @click="acceptCallback"
            >Submit
          </BButton>
          <BButton class="btn btn-light" @click="rejectCallback"
            >Cancel
          </BButton>
        </div>
      </div>
    </template>
  </ConfirmDialog>
</template>

<script setup>
/* eslint-disable */
import ConfirmDialog from "primevue/confirmdialog";
import { useConfirm } from "primevue/useconfirm";
import "primeflex/primeflex.css";
import { toast } from "vue3-toastify";
import { onMounted, ref, computed, defineProps, watch } from "vue";
import Dialog from "primevue/dialog";
import Avatar from "primevue/avatar";

const confirm = useConfirm();
const actionType = ref(null);
const visible = ref(false);
const showPass = ref(false);
const showConfirmPass = ref(false);
const reset_pass_form = ref({
  usr_id: null,
  usr_password: "",
  usr_confirm_pass: "",
});
const selectedUser = ref(null);
const is_valid_user_pass = ref(null);
const is_valid_user_confirm_pass = ref(null);
const confirm_pass_val_msg = ref(null);
const userListObject = ref([]);

const props = defineProps(["toBeRefreshed"]);

// watchEffect(() => {
//   // runs only once before 3.5
//   // re-runs when the "toBeRefreshed" prop changes in 3.5+

// });

watch(
  () => props.toBeRefreshed,
  (newValue, oldValue) => {
    // React to prop changes

    fetchUserList();
  },
);

const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  status: { value: null, matchMode: FilterMatchMode.EQUALS },
});

const columns = [
  { field: "usr_user_name", header: "User Name" },
  { field: "usr_email", header: "Email" },
  { field: "url_role_desc", header: "Role" },
  { field: "usr_created_by", header: "Created By" },
  // { field: 'usr_created_on', header: 'Created On' },
];

const passwordRequirements = computed(() => [
  {
    name: "Must contain uppercase letters",
    predicate:
      reset_pass_form.value.usr_password.toLowerCase() !==
      reset_pass_form.value.usr_password,
  },
  {
    name: "Must contain lowercase letters",
    predicate:
      reset_pass_form.value.usr_password.toUpperCase() !==
      reset_pass_form.value.usr_password,
  },
  {
    name: "Must contain numbers",
    predicate: /\d/.test(reset_pass_form.value.usr_password),
  },
  {
    name: "Must contain symbols",
    predicate: /\W/.test(reset_pass_form.value.usr_password),
  },
  {
    name: "Must be at least 8 characters long",
    predicate: reset_pass_form.value.usr_password.length >= 8,
  },
  {
    name: "Must match Password and Confirm Password",
    predicate:
      reset_pass_form.value.usr_confirm_pass != "" &&
      reset_pass_form.value.usr_password ===
        reset_pass_form.value.usr_confirm_pass,
  },
]);

const onChangePass = (event) => {
  passwordRequirements,
    () => {
      passwordRequirements.value.reduce((v, p) => v && p.predicate, true);
    };
};

const manageActiveStatus = (objselectedItem) => {
  actionType.value = objselectedItem.usr_status == 1 ? "deactive" : "active";

  confirm.require({
    group: "headless",
    header: "Are you sure?",
    message:
      objselectedItem.usr_status == 1
        ? "Please confirm to deactivate the user."
        : "Please confirm to activate the user",
    accept: () => {
      // toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
      if (objselectedItem.usr_status == 1) objselectedItem.usr_status = 0;
      else objselectedItem.usr_status = 1;

      axios
        .post("/manage_user_status?usr_id=" + objselectedItem.usr_id)
        .then((res) => {
          if (
            res.data != undefined &&
            res.data.retVal != undefined &&
            res.data.retVal != null &&
            res.data.retVal == 1
          ) {
            toast(res.data.message, {
              autoClose: 2000,
              theme: "colored",
              type: "success",
              position: "bottom-left",
              dangerouslyHTMLString: true,
            });

            fetchUserList();
          }
        })
        .catch((err) => {
          toast(err.response.data.detail, {
            autoClose: 2000,
            theme: "colored",
            type: "error",
            position: "bottom-left",
            dangerouslyHTMLString: true,
          });
        });
    },
    reject: () => {
      return;
    },
  });
};

const btnResetPassClick = (objselectedItem) => {
  selectedUser.value = objselectedItem;

  reset_pass_form.value.usr_id = null;
  reset_pass_form.value.usr_confirm_pass = "";
  reset_pass_form.value.usr_password = "";
  visible.value = true;
};

const resetPassword = () => {
  if (validateResetPassForm()) {
    reset_pass_form.value.usr_id = selectedUser.value.usr_id;
    reset_pass_form.value.usr_password = AESEncryptData(
      reset_pass_form.value.usr_password,
    ); //AESEncryptData(reset_pass_form.value.usr_password)
    axios
      .post("/reset_user_pass", reset_pass_form.value)
      .then((res) => {
        if (
          res.data != undefined &&
          res.data.retVal != undefined &&
          res.data.retVal != null &&
          res.data.retVal == 1
        ) {
          visible.value = false;
          toast(res.data.message, {
            autoClose: 2000,
            theme: "colored",
            type: "success",
            position: "bottom-left",
            dangerouslyHTMLString: true,
          });

          //todo refresh the list
        }
      })
      .catch((err) => {
        if (
          err != undefined &&
          err != null &&
          err.response != undefined &&
          err.response != null &&
          err.response.data != undefined &&
          err.response.data != null
        ) {
          toast(err.response.data.detail, {
            autoClose: 2000,
            theme: "colored",
            type: "error",
            position: "bottom-left",
            dangerouslyHTMLString: true,
          });
        }
      });
  }
};

function validateResetPassForm() {
  is_valid_user_pass.value =
    reset_pass_form.value.usr_password == "" ? false : true;
  is_valid_user_confirm_pass.value =
    reset_pass_form.value.usr_confirm_pass == "" ? false : true;
  confirm_pass_val_msg.value =
    reset_pass_form.value.usr_confirm_pass == ""
      ? "Enter Confirm Password"
      : null;
  if (
    reset_pass_form.value.usr_confirm_pass != undefined &&
    reset_pass_form.value.usr_confirm_pass != null &&
    reset_pass_form.value.usr_confirm_pass.length > 0 &&
    reset_pass_form.value.usr_password !==
      reset_pass_form.value.usr_confirm_pass
  ) {
    is_valid_user_confirm_pass.value = false;
    confirm_pass_val_msg.value = "Password and confirm Password are mismatch";
  }

  if (
    !is_valid_user_pass.value ||
    !is_valid_user_confirm_pass.value ||
    passwordRequirements.value.find((u) => u.predicate == false) != null
  )
    return false;
  else return true;
}

const exportToCSV = () => {
  axios
    .get("/export_user_detail")
    .then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "User_Details.csv");
      document.body.appendChild(link);
      link.click();
    })
    .catch((err) => {
      // toast(err.response.data.detail, {
      //     autoClose: 2000,
      //     theme: "colored",
      //     type: "error",
      //     position: "bottom-left",
      //     dangerouslyHTMLString: true,
      // });
    });
};

function formatDateTime(value) {
  if (value != null) return format(value, "MMM dd, yyyy").toLocaleString();
  return "";
}

onMounted(() => {
  fetchUserList();
});

const fetchUserList = async () => {
  await axios
    .post("/fetch_users")
    .then((res) => {
      if (res.data != null && res.data.length > 0) {
        userListObject.value = res.data;
      }
    })
    .catch((err) => {});
};
</script>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { FilterMatchMode } from "primevue/api";
import { format } from "date-fns";
import axios from "axios";
import { AESEncryptData } from "@/utils/common-function";

export default {
  name: "UserList",
  //   props: {
  //     limitOfRecords: Number,
  //     userListObject: [],
  //   },
  components: {
    DataTable,
    Column,
    Dialog,
    ConfirmDialog,
    // ConfirmModal
  },
  data() {},

  methods: {
    editUserDetails(objselectedItem) {
      this.$emit("selected-data", objselectedItem);
    },
  },
};
</script>

<style scoped>
.requirements {
  font-weight: 400;
}

.is-success {
  color: #96ca2d;
}

.is-error {
  color: #ba3637;
}
</style>
